export const mapTree = (originTree) => {
    if (originTree.length > 0) {
        const res = originTree.map((org, index) => ({
            key: org.org.id,
            id: org.org.id,
            label: org.org.org_name,
            children: mapTree(org.sub_orgs),
        }));
        return res;
    }
    else {
        return [];
    }
};
